module.exports = __webpack_public_path__ + "img/logo-syg.91525a82.svg";